// ? 全局默认配置项
import backgroundImage from "@/assets/images/website/backgroundImage.png";
import logoImage from "@/assets/images/website/logo.png";

// 首页地址（默认）
export const HOME_URL = "/home";

// 登录页地址（默认）
export const LOGIN_URL = "/login";

// 路由白名单地址（必须是本地存在的路由 staticRouter.ts 中）
export const ROUTER_WHITE_LIST: string[] = [
	"register",
	"registrationAgreement",
	"customerServices",
	"start",
	"privacyPolicy",
	"deficonnect",
	"deficonnect-id"
];

/** 默认的website */
export const websiteInfo = {
	backgroundImage: backgroundImage,
	logo: logoImage,
	popUpImage: "",
	copyright: "",
	currencyUnit: "USD",
	name: "Bulldog Marketing Agency"
};

/** 白背景的路由 */
export const WHITE_BG_ROUTE_NAME: string[] = [];
export const NO_COPY_RIGHT: string[] = ["start"];
const imgExts = [".png", ".jpg", ".jpeg", ".bmp", ".gif", ".webp", ".psd", ".svg", ".tiff"];
const audioExts = [".mp3", ".wav", ".ogg"];
const videoExts = [".mp4", ".avi", ".mov", ".mpeg", "quicktime"];

const getExtension = (url: string) => {
	const i = url.lastIndexOf(".");
	if (i > -1) {
		const paramIndex = url.lastIndexOf("?");
		return paramIndex >= 0 ? url.substring(i, paramIndex).toLowerCase() : url.substring(i).toLowerCase();
	}
	return "";
};

/**
 * @description 判断是否是图片
 * @param {String} url 媒体地址
 * @return persist
 * */
export const isImage = (url: string) => {
	return imgExts.includes(getExtension(url));
};

/**
 * @description 判断是否是音频
 * @param {String} url 媒体地址
 * @return persist
 * */
export const isAudio = (url: string) => {
	return audioExts.includes(getExtension(url));
};

/**
 * @description 判断是否是视频
 * @param {String} url 媒体地址
 * @return persist
 * */
export const isVideo = (url: string) => {
	return videoExts.includes(getExtension(url));
};

export const REDIRECT_URL_TOKEN_KEY = "REDIRECT_URL_TOKEN_KEY";
